document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.floating-button, .floating-button-mobile');

    function smoothScroll(event) {
        event.preventDefault();
        const href = event.currentTarget.getAttribute('href');
        const targetId = href.startsWith('#') ? href.substring(1) : null;

        if (targetId) {
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                const offset = 100;
                const elementPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth',
                });
            }
        }
    }

    buttons.forEach((button) => {
        button.addEventListener('click', smoothScroll);
    });

    // Reattach event listeners in case of DOM updates
    const observer = new MutationObserver(() => {
        buttons.forEach((button) => {
            button.removeEventListener('click', smoothScroll);
            button.addEventListener('click', smoothScroll);
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener('DOMContentLoaded', function () {
        // Mobile TOC button functionality
    var openButtonMobile = document.getElementById('open-toc-button-mobile');
    var closeButton = document.getElementById('close-toc-button');
    var menuMobile = document.getElementById('toc-menu-mobile');
    var links = document.querySelectorAll('.toc-link');
    var floatingButtonSection = document.querySelector('.floating-button-section');

    openButtonMobile.addEventListener('click', function () {
        menuMobile.classList.add('show');
        openButtonMobile.classList.add('active');
        closeButton.style.display = 'block';
        if (floatingButtonSection) {
            floatingButtonSection.classList.add('hidden');
        }
    });

    closeButton.addEventListener('click', function () {
        menuMobile.classList.remove('show');
        openButtonMobile.classList.remove('active');
        closeButton.style.display = 'none';
        if (floatingButtonSection) {
            floatingButtonSection.classList.remove('hidden');
        }
    });

    links.forEach(function (link) {
        link.addEventListener('click', function (event) {
            event.preventDefault();
            var targetId = this.getAttribute('href').substring(1);
            var targetElement = document.getElementById(targetId);
            var headerOffset = 120; // 100 pixels offset
            var elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
            var offsetPosition = elementPosition - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });

            menuMobile.classList.remove('show');
            openButtonMobile.classList.remove('active');
            closeButton.style.display = 'none';
            if (floatingButtonSection) {
                floatingButtonSection.classList.remove('hidden');
            }
        });
    });

    // Desktop TOC button functionality
    var tocButtonDesktop = document.getElementById('toc-button-desktop');
    var tocMenuDesktop = document.getElementById('toc-menu-desktop');
    var closeButtonDesktop = document.getElementById('close-toc-button-desktop');

    tocButtonDesktop.addEventListener('click', function () {
        tocButtonDesktop.classList.toggle('expanded');
        if (tocButtonDesktop.classList.contains('expanded')) {
            tocMenuDesktop.style.display = 'flex';
            if (floatingButtonSection) {
                floatingButtonSection.classList.add('hidden');
            }
        } else {
            tocMenuDesktop.style.display = 'none';
            if (floatingButtonSection) {
                floatingButtonSection.classList.remove('hidden');
            }
        }
    });

    closeButtonDesktop.addEventListener('click', function (event) {
        event.stopPropagation();
        tocButtonDesktop.classList.remove('expanded');
        tocMenuDesktop.style.display = 'none';
        if (floatingButtonSection) {
            floatingButtonSection.classList.remove('hidden');
        }
    });

    window.addEventListener('scroll', function () {
        tocButtonDesktop.classList.remove('expanded');
        tocMenuDesktop.style.display = 'none';
        if (floatingButtonSection) {
            floatingButtonSection.classList.remove('hidden');
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    var tocButtonDesktop = document.querySelector('.toc-button-desktop');
    var tocButtonMobile = document.querySelector('.toc-button-mobile');
    var floatingButton = document.querySelector('.floating-button-section');

    // Function to toggle display based on the classes for both desktop and mobile
    function toggleFloatingButtonDisplay() {
        if (floatingButton) {
            // Check for toc-button-desktop with expanded class
            if (tocButtonDesktop && tocButtonDesktop.classList.contains('expanded')) {
                floatingButton.style.display = 'none';
            }
            // Check for toc-button-mobile with active class
            else if (tocButtonMobile && tocButtonMobile.classList.contains('active')) {
                floatingButton.style.display = 'none';
            }
            // Show the floating button if neither class is present
            else {
                floatingButton.style.display = '';
            }
        }
    }

    // Initial check when the page loads
    toggleFloatingButtonDisplay();

    // Observe changes for toc-button-desktop
    if (tocButtonDesktop) {
        var observerDesktop = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.attributeName === 'class') {
                    toggleFloatingButtonDisplay();
                }
            });
        });
        observerDesktop.observe(tocButtonDesktop, { attributes: true });
    }

    // Observe changes for toc-button-mobile
    if (tocButtonMobile) {
        var observerMobile = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.attributeName === 'class') {
                    toggleFloatingButtonDisplay();
                }
            });
        });
        observerMobile.observe(tocButtonMobile, { attributes: true });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const accordionButtons = document.querySelectorAll(
        '.references-ccordion .shogun-accordion-header .shogun-accordion-title'
    );

    if (accordionButtons.length === 0) {
        console.warn('No accordion buttons found with the specified selector');
        return;
    }

    accordionButtons.forEach((btn) => {
        console.log("All accordion buttons:", btn);
        btn.addEventListener('click', (event) => {
        console.log("Accordion button clicked:", event.target);
        const toggleContent = event.target.closest('.shogun-accordion');
        console.log("toggleContent", toggleContent) // Note: Typo in original ('accordion' vs 'accordion')
        if (!toggleContent) {
            console.error('Could not find parent accordion element');
            return;
        }

        const toggleBody = toggleContent.querySelector('.shogun-accordion-body');
        if (!toggleBody) {
            console.error('Could not find accordion body element');
            return;
        }

        const isOpen = toggleContent.classList.contains('shogun-accordion-active');
        console.log("isOpen", isOpen);
        toggleContent.classList.toggle('shogun-accordion-active', !isOpen);
        toggleBody.classList.toggle('shogun-accordion-active', !isOpen);
        });
    });

    document.querySelectorAll('.references-ccordion .shogun-accordion-title').forEach((accordionEl) => {
        console.log('Accordion element:', accordionEl);
        accordionEl.addEventListener('click', (titleEl) => {
        let bodyAccodian = titleEl.target.parentNode.parentNode.parentNode.querySelector('.shogun-accordion-body');
        let heightActiveAccordion = titleEl.target.parentNode.parentNode.parentNode.querySelector(
            '.shogun-accordion-body .shg-c .shg-theme-text-content'
        ).offsetHeight;
        console.log(bodyAccodian);
        if (bodyAccodian.classList.contains('shogun-accordion-active'))
            bodyAccodian.style.height = heightActiveAccordion + 'px';
        else bodyAccodian.style.height = '0px';
        });
    });
});